import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { FaHome, FaFileAlt, FaWrench, FaCreditCard, FaCog, FaSignOutAlt, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import logo from '../Assets/RSIDE.png';
import '../PropertyManager/Sidebar.css';

function TenantSidebar({ initials }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const originalUid = useRef(auth.currentUser?.uid || null);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(user => {
      if (!user) { navigate('/tenant/login'); return; }
      if (originalUid.current && user.uid !== originalUid.current) {
        navigate('/tenant/login');
      }
    });
    return unsub;
  }, [navigate]);

  useEffect(() => {
    document.body.classList.toggle('sidebar-collapsed', collapsed);
    return () => document.body.classList.remove('sidebar-collapsed');
  }, [collapsed]);

  const isActive = (path) => location.pathname.startsWith(path);
  const closeMobile = () => document.body.classList.remove('sidebar-mobile-open');
  const navTo = (path) => { navigate(path); closeMobile(); };

  const handleLogout = async () => {
    closeMobile();
    await signOut(auth);
    navigate('/tenant/login');
  };

  return (
    <>
      <div className="sidebar-mobile-backdrop" onClick={() => document.body.classList.remove('sidebar-mobile-open')} />
      <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
        <button className="sidebar-toggle" onClick={() => setCollapsed(c => !c)} title={collapsed ? 'Expand' : 'Collapse'}>
          {collapsed ? <FaAngleDoubleRight /> : <FaAngleDoubleLeft />}
        </button>

        <div className="sidebar-header">
          <div className="sidebar-logo-wrap">
            <img src={logo} alt="RSIDE" className="sidebar-logo" />
          </div>
        </div>

        <div className="sidebar-nav">
          <div className={`nav-item ${isActive('/tenant/home') ? 'active' : ''}`} onClick={() => navTo('/tenant/home')} title="Home">
            <FaHome className="nav-icon" />
            {!collapsed && <span className="nav-label">Home</span>}
          </div>
          <div className={`nav-item ${isActive('/tenant/documents') ? 'active' : ''}`} onClick={() => navTo('/tenant/documents')} title="Documents">
            <FaFileAlt className="nav-icon" />
            {!collapsed && <span className="nav-label">Documents</span>}
          </div>
          <div className={`nav-item ${isActive('/tenant/maintenance') ? 'active' : ''}`} onClick={() => navTo('/tenant/maintenance')} title="Maintenance">
            <FaWrench className="nav-icon" />
            {!collapsed && <span className="nav-label">Maintenance</span>}
          </div>
          <div className={`nav-item ${isActive('/tenant/payments') ? 'active' : ''}`} onClick={() => navTo('/tenant/payments')} title="Payments">
            <FaCreditCard className="nav-icon" />
            {!collapsed && <span className="nav-label">Payments</span>}
          </div>
        </div>

        <div className="sidebar-footer">
          <div className={`nav-item ${isActive('/tenant/settings') ? 'active' : ''}`} onClick={() => navTo('/tenant/settings')} title="Settings">
            <FaCog className="nav-icon" />
            {!collapsed && <span className="nav-label">Settings</span>}
          </div>
          <div className="nav-item" onClick={handleLogout} title="Logout">
            <FaSignOutAlt className="nav-icon" />
            {!collapsed && <span className="nav-label">Logout</span>}
          </div>
        </div>
      </div>
    </>
  );
}

export default TenantSidebar;
